import * as React from "react";
const SVGComponent = (props) => (
  <svg
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    width={256}
    height={256}
    viewBox="0 0 256 256"
    {...props}
  >
    <defs>
      <style>{"\n      .cls-1 {\n        fill: #c88242;\n      }\n    "}</style>
    </defs>
    <path
      className="cls-1"
      d="M244.5,108.7c-1.4-6.6-5.2-12.8-9.3-18.3,0,0-13.8-33.5-32.2-44s-71.5-16.5-71.5-16.5c-12.7-2.2-46.2,4.7-56.4,7.8-20.4,4.2-33.7,19.8-44.2,36.7-16.8,27.2-23.9,58.8-18.3,89.3,3.2,17.2,11.9,31.3,26.5,42.5,1.8,1.4,3.9,2.7,6.2,4,9.9-38.7,23.7-69.9,53.3-98.6-15.8,2-30.4-1.7-39.2-14.2-3.6-5.1-5.5-13.3-1.5-18,6.3-7.3,15.7-6.8,25.5-6.4-2.9-3.9-5.6-12.8-1.6-14.5,9.2-3.9,17.4,3.4,25.6,7l-3.4-16.2c2.3-1.5,8.9-1.6,11,0l18,13.5-.3-19.3c14.1,2.6,20.5,12,27.2,21.6l3.3-9.1c11.3,5.8,18.8,14.8,21.1,26.6l1.1,5.6c.3,1.2,4.4,1.6,5.9,2.1,6.5,9.3,5.4,24.4-3.3,33.2-3,3-7.5,4.4-12.6,5.7,9.3,2.7,17.7,8.1,21.6,18.2l-27.2.5c7.1,11.7,13.1,20.4,16.5,32.1,3,10.2-2,22.5-12.7,25-8.5,2-14.1-4.3-20.3-10.2l9.7,31.5c5.2-.7,10.2-1.5,14.6-2.7,13.8-3.6,25.8-11.3,37-19.6,13.7-10.2,21.4-24.2,23.5-40,.2-1.2.3-2.5.5-3.7,3.2-10.3,4.6-21.1,5.6-31.8.6-6.7,1.6-13.5.2-20.1Z"
    />
    <path
      className="cls-1"
      d="M147.9,124.3c3.8,1.5,3.6,5.6,6.4,7.3,1.8-3.4.9-6-.5-8.9-1.6-3.1-5.3-4.8-8.9-4.1-5.1,1-8.8,7.2-6.6,11.4l4.2-4.4c1.1-1.1,4.1-1.8,5.4-1.2Z"
    />
  </svg>
);
export default SVGComponent;
